import { defineStore } from "pinia";
import { useFetch } from "#app";
import type {
  INNavaNumber,
  INNavaNumberPosted,
  INNavaNumberVerify,
  INavaAccount,
  IAccount,
  IMaxNumber,
  IUsersOperatorDefineStore,
} from "~/types/users/Operator";
import { useToastStore } from "@/stores/toast";
import { useUsersListStore } from '~/stores/users/list';
import { useUserStore } from "@/stores/user";

export const useUsersOperatorStore = defineStore("UsersOperatorStore", {
  state: (): IUsersOperatorDefineStore => ({
    error: null,
    nnavaNumber: [],
    nnavaNumberPosted: null,
    navaAccount: [],
    account: [],
    maxNumber: null,
  }),
  getters: {
    getOperatorName: (state: IUsersOperatorDefineStore) => (number: string) => {
      if (!state.nnavaNumber) return number;
      const user = state.nnavaNumber.find((item: INNavaNumber) => {
        return item.number == number;
      });
      if (!user) return number;
      return user.name || user.family
        ? `${user.name ?? ""} ${user.family ?? ""}`.trim()
        : number;
    },
    adminNumber: () => {
      const userStore = useUserStore();
      return userStore.user.adminNumber;
    },
  },
  actions: {
    async getNNavaNumber() {
      const toastStore = useToastStore();
      try {
        const { data, error } = await useFetch<INNavaNumber[]>(
          "/api/users/operator/nNavaNumber"
        );
        if(!data.value) return;
        this.nnavaNumber = data.value
        .map(item => ({
          ...item,
          isAdmin: item.number == this.adminNumber
        }))
        .sort((a, b) => {
          const aHasDash = String(a.number).includes('-');
          const bHasDash = String(b.number).includes('-');
        
          if (aHasDash && !bHasDash) return 1;
          if (!aHasDash && bHasDash) return -1;
          return 0;
        });
        this.error = error;
        if (error && error.value?.statusCode) {
          throw error;
        }

                return true
            } catch (err: any) {
                this.error = err;
                toastStore.showAlert({
                    title: "Can Not Connect To Server",
                    showCloseButton: true,
                    timerProgressBar: true,
                    type: "error"
                });
                return false
            }
        },
        async postNNavaNumber(params: INNavaNumber) {
            const toastStore = useToastStore();
            const usersListStore = useUsersListStore();
            const { subUsers } = usersListStore;

            try {
                await this.getMaxNumber();
                if (!this.nnavaNumber || this.nnavaNumber.length == 0) {
                    await this.getNNavaNumber();
                }
                if (this.maxNumber?.max_number <= this.nnavaNumber?.length) {
                    this.error = "Your number of authorized numbers is over";
                    toastStore.showAlert({
                        title: this.error,
                        showCloseButton: true,
                        timerProgressBar: true,
                        type: "error"
                    });
                    return false;
                }

                try {
                    const data = await $fetch<INNavaNumberPosted>('/api/users/operator/nNavaNumberPost', {
                        method: "POST",
                        body: {
                            ...params
                        }
                    });

                    this.nnavaNumberPosted = data;
                    this.nnavaNumberPosted.navanumber = params;
                    
                    subUsers.push({
                        uuid: "",
                        phoneNumber: params.phoneNumber,
                        role: params.role
                    })
                    return true
                } catch (err: any) {
                    const errorMessage = err?.data?.data?.error ?? "";
                    const isDuplicate = errorMessage.includes("duplicate");
                    const isFarsi = /[\u0600-\u06FF]/.test(errorMessage);

                    toastStore.showAlert({
                        title: isFarsi
                          ? errorMessage
                          : isDuplicate
                            ? "The entered number is duplicate"
                            : "Cannot connect to server",
                        showCloseButton: true,
                        timerProgressBar: true,
                        type: "error"
                    });
                    this.error = err;
                    if (err && err.value?.statusCode) {
                        throw err;
                    }
                    return false;
                }

                /*
                const { data, error } = await useFetch<INNavaNumberPosted>('/api/users/operator/nNavaNumberPost', {
                    method: 'POST',
                    body: params
                });
                this.error = error;
                if (error && error.value?.statusCode) {
                    throw error;
                }

                this.nnavaNumberPosted = data.value;
                this.nnavaNumberPosted.navanumber = params;
                return true
                */
            } catch (err: any) {
                this.error = err;
                toastStore.showAlert({
                    title: "Can Not Connect To Server",
                    showCloseButton: true,
                    timerProgressBar: true,
                    type: "error"
                });
                return false
            }
        },
        async postNNavaNumberVerify(params: INNavaNumberVerify) {
            const toastStore = useToastStore();

            try {
                const { data, error } = await useFetch<any>('/api/users/operator/nNavaNumberVerifyPost', {
                    method: 'POST',
                    body: params
                });
                this.error = error;
                if (error && error.value?.statusCode) {
                    throw error;
                } else if (data && data.value.error) {
                    //throw new Error(data.value.error);
                    return false
                }

        await this.getNNavaNumber();
        toastStore.showAlert({
          title: "NNavaNumber Insert Successfully",
          showCloseButton: true,
          timerProgressBar: true,
        });
        return true;
      } catch (err: any) {
        this.error = err;
        toastStore.showAlert({
          title: "Can Not Connect To Server",
          showCloseButton: true,
          timerProgressBar: true,
          type: "error",
        });
        return false;
      }
    },
    async deleteNNavaNumber(params: INNavaNumber) {
      const toastStore = useToastStore();
      try {
        const { error } = await useFetch<any>(
          "/api/users/operator/nNavaNumberDelete",
          {
            method: "DELETE",
            body: params,
          }
        );
        this.error = error;
        if (error && error.value?.statusCode) {
          throw error;
        }

                this.nnavaNumber = this.nnavaNumber?.filter(item => item.number != params.number);
                toastStore.showAlert({
                    title: "NNavaNumber Delete Successfully",
                    showCloseButton: true,
                    timerProgressBar: true,
                });
                return true
            } catch (err: any) {
                this.error = err;
                toastStore.showAlert({
                    title: "Can Not Connect To Server",
                    showCloseButton: true,
                    timerProgressBar: true,
                    type: "error"
                });
                return false
            }
        },
        async putNNavaNumber(params: INNavaNumber) {
            const usersListStore = useUsersListStore();
            const { subUsers } = usersListStore;

            const toastStore = useToastStore();
            try {
                const { error } = await useFetch<any>('/api/users/operator/nNavaNumberPut', {
                    method: 'PUT',
                    body: params
                });
                this.error = error;
                if (error && error.value?.statusCode) {
                    throw error;
                }

                let index = this.nnavaNumber.findIndex(item => item.number == params.phoneNumber);
                this.nnavaNumber[index].name = params.firstName;
                this.nnavaNumber[index].family = params.lastName;
                this.nnavaNumber[index].internals = params.internal;

                const targetUser = subUsers?.find(user => (user.phoneNumber == params.phoneNumber))
                if(targetUser) {
                    Object.assign(targetUser, {
                        role: params.role,
                    });
                }
                toastStore.showAlert({
                    title: "NNavaNumber Update Successfully",
                    showCloseButton: true,
                    timerProgressBar: true,
                });
                return true
            } catch (err: any) {
                this.error = err;
                toastStore.showAlert({
                    title: "Can Not Connect To Server",
                    showCloseButton: true,
                    timerProgressBar: true,
                    type: "error"
                });
                return false
            }
        },

        async getNavaAccount() {
            const toastStore = useToastStore();
            try {
                const { data, error } = await useFetch<INavaAccount[]>('/api/users/operator/navaAccount');
                this.error = error;
                if (error && error.value?.statusCode) {
                    throw error;
                }
                if(!data.value) return true;
                this.navaAccount = data.value.map(({ user, ...rest }) => ({ ...rest, userName: user }));
                return true
            } catch (err: any) {
                this.error = err;
                toastStore.showAlert({
                    title: "Can Not Connect To Server",
                    showCloseButton: true,
                    timerProgressBar: true,
                    type: "error"
                });
                return false
            }
        },
        async postNavaAccount(params: INavaAccount) {
            const toastStore = useToastStore();
            const usersListStore = useUsersListStore();
            const { subUsers } = usersListStore;

            try {
                await this.getMaxNumber();
                if (!this.nnavaNumber || this.nnavaNumber.length == 0) {
                    await this.getNNavaNumber();
                }
                if (this.maxNumber?.max_number <= this.nnavaNumber?.length) {
                    this.error = "Your number of authorized numbers is over";
                    toastStore.showAlert({
                        title: this.error,
                        showCloseButton: true,
                        timerProgressBar: true,
                        type: "error"
                    });
                    return false;
                }

                try {
                    const data = await $fetch<INNavaNumberPosted>('/api/users/operator/navaAccountPost', {
                        method: "POST",
                        body: {
                            ...params
                        }
                    });
                    params.id = data;
                    params.userName = params.user;
                    delete params.user;
                    if (!this.navaAccount) this.navaAccount = [];

                    subUsers.push({
                      uuid: "",
                      phoneNumber: params.userName,
                      role: params.role
                    })

                    this.navaAccount.push(params);
                    toastStore.showAlert({
                        title: "NavaAccount Insert Successfully",
                        showCloseButton: true,
                        timerProgressBar: true,
                    });
                    return true
                } catch (err: any) {
                    const isDuplicate = err?.data?.data?.error.includes("Duplicate")
                    toastStore.showAlert({
                        title: isDuplicate ? "The entered username is duplicate" : "Can Not Connect To Server",
                        showCloseButton: true,
                        timerProgressBar: true,
                        type: "error"
                    });

                    this.error = err;
                    if (err && err.value?.statusCode) {
                        throw err;
                    }
                    return false;
                }

                /*
                const { data, error } = await useFetch<any>('/api/users/operator/navaAccountPost', {
                    method: 'POST',
                    body: params
                });
                this.error = error;
                if (error && error.value?.statusCode) {
                    throw error;
                }

        params.id = data.value;
        if (!this.navaAccount) this.navaAccount = [];
        this.navaAccount.push(params);
        toastStore.showAlert({
          title: "NavaAccount Insert Successfully",
          showCloseButton: true,
          timerProgressBar: true,
        });
        return true;
                */
      } catch (err: any) {
        this.error = err;
        toastStore.showAlert({
          title: "Can Not Connect To Server",
          showCloseButton: true,
          timerProgressBar: true,
          type: "error",
        });
        return false;
      }
    },
    async deleteNavaAccount(params: INavaAccount) {
      const toastStore = useToastStore();
      try {
        const { error } = await useFetch<any>(
          "/api/users/operator/navaAccountDelete",
          {
            method: "DELETE",
            body: params,
          }
        );
        this.error = error;
        if (error && error.value?.statusCode) {
          throw error;
        }

                this.navaAccount = this.navaAccount?.filter(item => item.id != params.id);
                toastStore.showAlert({
                    title: "NavaAccount Delete Successfully",
                    showCloseButton: true,
                    timerProgressBar: true,
                });
                return true
            } catch (err: any) {
                this.error = err;
                toastStore.showAlert({
                    title: "Can Not Connect To Server",
                    showCloseButton: true,
                    timerProgressBar: true,
                    type: "error"
                });
                return false
            }
        },
        async putNavaAccount(params: any) {
            const toastStore = useToastStore();
            const usersListStore = useUsersListStore();
            const { subUsers } = usersListStore;

            try {
              const data = await $fetch<any>('/api/users/operator/navaAccountPut', {
                method: "PUT",
                body: params
              });
              const userAccount = this.navaAccount.find((item) => item.id == params.id);
              if (userAccount) {
                Object.assign(userAccount, {
                  ...params,
                });
              }

              const targetUser = subUsers?.find(user => (user.phoneNumber == params.user))
                if(targetUser) {
                  Object.assign(targetUser, {
                    role: params.role,
                  });
                }

              toastStore.showAlert({
                title: "NNavaNumber Update Successfully",
                showCloseButton: true,
                timerProgressBar: true,
              });
              return true
            } catch (err: any) {
              toastStore.showAlert({
                title: "Can Not Connect To Server",
                showCloseButton: true,
                timerProgressBar: true,
                type: "error"
              });
              return false
            }
        },

    async getAccount() {
      const toastStore = useToastStore();
      try {
        const { data, error } = await useFetch<IAccount[]>(
          "/api/users/operator/account"
        );
        this.error = error;
        if (error && error.value?.statusCode) {
          throw error;
        }

                this.account = data.value;
                return true
            } catch (err: any) {
                this.error = err;
                toastStore.showAlert({
                    title: "Can Not Connect To Server",
                    showCloseButton: true,
                    timerProgressBar: true,
                    type: "error"
                });
                return false
            }
        },
        async postAccount(params: IAccount) {
            const toastStore = useToastStore();
            try {
                await this.getMaxNumber();
                if (!this.nnavaNumber || this.nnavaNumber.length == 0) {
                    await this.getNNavaNumber();
                }
                if (this.maxNumber?.max_number <= this.nnavaNumber?.length) {
                    this.error = "Your number of authorized numbers is over";
                    toastStore.showAlert({
                        title: this.error,
                        showCloseButton: true,
                        timerProgressBar: true,
                        type: "error"
                    });
                    return;
                }

                try {
                    const data = await $fetch<INNavaNumberPosted>('/api/users/operator/accountPost', {
                        method: "POST",
                        body: {
                            ...params
                        }
                    });

                    params.id = data;
                    if (!this.account) this.account = [];
                    this.account.push(params);
                    toastStore.showAlert({
                        title: "Account Insert Successfully",
                        showCloseButton: true,
                        timerProgressBar: true,
                    });
                    return true
                } catch (err: any) {
                    this.error = err;
                    if (err && err.value?.statusCode) {
                        throw err;
                    }
                }

                /*
                const { data, error } = await useFetch<any>('/api/users/operator/accountPost', {
                    method: 'POST',
                    body: params
                });
                this.error = error;
                if (error && error.value?.statusCode) {
                    throw error;
                }

                params.id = data.value;
                if (!this.account) this.account = [];
                this.account.push(params);
                toastStore.showAlert({
                    title: "Account Insert Successfully",
                    showCloseButton: true,
                    timerProgressBar: true,
                });
                return true
                */
            } catch (err: any) {
                this.error = err;
                toastStore.showAlert({
                    title: "Can Not Connect To Server",
                    showCloseButton: true,
                    timerProgressBar: true,
                    type: "error"
                });
                return false
            }
        },
        async deleteAccount(params: IAccount) {
            const toastStore = useToastStore();
            try {
                const { error } = await useFetch<any>('/api/users/operator/accountDelete', {
                    method: 'DELETE',
                    body: params
                });
                this.error = error;
                if (error && error.value?.statusCode) {
                    throw error;
                }

                this.account = this.account?.filter(item => item.id != params.id);
                toastStore.showAlert({
                    title: "Account Delete Successfully",
                    showCloseButton: true,
                    timerProgressBar: true,
                });
                return true
            } catch (err: any) {
                this.error = err;
                toastStore.showAlert({
                    title: "Can Not Connect To Server",
                    showCloseButton: true,
                    timerProgressBar: true,
                    type: "error"
                });
                return false
            }
        },
        async putAccount(params: any) {
            const toastStore = useToastStore();

            try {
              const data = await $fetch<any>('/api/users/operator/accountPut', {
                method: "PUT",
                body: params
              });
              const userAccount = this.account.find((item) => item.id == params.id);
              if (userAccount) {
                Object.assign(userAccount, {
                  ...params,
                });
              }
              toastStore.showAlert({
                title: "NNavaNumber Update Successfully",
                showCloseButton: true,
                timerProgressBar: true,
              });
              return true
            } catch (err: any) {
              toastStore.showAlert({
                title: "Can Not Connect To Server",
                showCloseButton: true,
                timerProgressBar: true,
                type: "error"
              });
              return false
            }
        },

    async getMaxNumber() {
      const toastStore = useToastStore();
      try {
        this.maxNumber = { max_number: 0 };
        const { data, error } = await useFetch<IMaxNumber>(
          "/api/users/operator/maxNumber"
        );
        this.error = error;
        if (error && error.value?.statusCode) {
          throw error;
        }

        this.maxNumber = data.value;
        return true;
      } catch (err: any) {
        this.error = err;
        toastStore.showAlert({
          title: "Can Not Connect To Server",
          showCloseButton: true,
          timerProgressBar: true,
          type: "error",
        });
        return false;
      }
    },
  },

  persist: {
    storage: persistedState.localStorage,
  },
});
